import React from 'react'
import './index.scss'

/**
 * 
 * @param {Any} value - Value to be checked, true or false
 * @param {Boolean} disabled - If true, the radio will be disabled
 * @param {Function} onChange - Function to be called when the radio is changed, response the value of the radio
 * 
 * @returns {React.ReactElement}
 */

function Radio({ value = false, disabled = false, onChange = checked => { }, ...props }) {
  return (
    <div className={disabled ? "radio radio--disabled" : "radio"} onClick={() => onChange(!value)} {...props}>
      <input type="radio" checked={value} onChange={() => {}}/>
      <span className={value ? "radio__checkmark radio__checkmark--checked" : "radio__checkmark"}>
        {value && <span className="radio__checkmark__circle"></span>}
      </span>
    </div>

  )
}

export default Radio
